import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import theme from "../../../../themes/themes";
import { format, isAfter, differenceInDays, isValid } from "date-fns";
import InfoIcon from "../../../../assets/icons/InfoIcon";
import WarningIcon from "../../../../assets/icons/WarningIcon";
import ErrorIcon from "../../../../assets/icons/ErrorIcon";
import { Box } from "@mui/material";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";

export default function CarrierProfileInsuranceIndicator({ date }) {
  const [expirationStatus, setExpirationStatus] = useState("");
  const warningThreshold = 30;

  const getExpirationStatus = date => {
    if (!isValid(date) || (isValid(date) && isAfter(new Date(), date))) {
      return "Expired";
    } else if (isValid(date) && differenceInDays(date, new Date()) <= warningThreshold) {
      return "Expiring";
    } else {
      return "Expires";
    }
  };

  const getIcon = () => {
    if (expirationStatus === "Expiring") {
      return <WarningIcon color={theme.palette["warning"]["70"]} sx={{ fontSize: "20px" }} />;
    } else if (expirationStatus === "Expired") {
      return <ErrorIcon color={theme.palette["error"]["70"]} sx={{ fontSize: "20px" }} />;
    } else {
      return <InfoIcon color={theme.palette["black_opacity"]["70"]} sx={{ fontSize: "20px" }} />;
    }
  };

  useEffect(() => {
    setExpirationStatus(getExpirationStatus(date));
  }, [date]);

  return (
    <StyledTooltip title={`${expirationStatus} ${isValid(date) && format(date, "MM/dd/yyyy")}`}>
      <Box>
        {getIcon()}
      </Box>
    </StyledTooltip>
  );
}

CarrierProfileInsuranceIndicator.propTypes = {
  date: PropTypes.any
};